
import EmptyHome from '@/ui/components/Home/Empty/EmptyHome'
import Teaser from '@/ui/components/Teaser/Teaser'
import AssistantCard from '@/ui/components/AssistantCard/AssistantCard'

// utils
import { getAssistantIllustration } from '@/hooks/useAssistantIllustration'
import { titleSizes } from '@/constants'
import { HomeProperties } from '@/ui/components/Home/types'
import { DisplayMode } from '@/ui/types/DisplayMode'
import utils from '@/utils/utils'

import './MobileHome.scss'

const MobileHome = ({ space, information, translate, tileHandler }: HomeProperties) => {
    const hasAssistants = space?.assistants && space?.assistants.length > 0
    const rawName = information?.account?.name || information?.account?.username
    const givenName = utils.extractFirstName(rawName)

    let greetingsTitle = translate('home:greetingsTitle')

    if (givenName)
        greetingsTitle = `${greetingsTitle}, ${givenName}?`

    return (
        <div className='mobile-home'>
            <div className='home-assistants'>
                <div className='home-assistants-wrapper'>
                    <div className='home-image'>
                        <img src={getAssistantIllustration()} alt='Assistant Logo' />
                    </div>
                    <p className={`title -size-${titleSizes[5]}`}>{greetingsTitle}</p>
                </div>

                {
                    !hasAssistants &&
                    <EmptyHome
                        information={information}
                        translate={translate}
                    />
                }

                {
                    hasAssistants &&
                    <Teaser columns={2}>
                        {
                            space.assistants.map((assistant, index) => {
                                const appearance = assistant.config.appearance
                                const name = utils.checkDefaultName(translate(`${assistant.config.id}:name`), assistant) ?? ''
                                const badges = utils.getAssistantBadges(assistant)
                                
                                return (
                                    <AssistantCard
                                        key={index}
                                        icon={appearance.icon}
                                        iconSrc={appearance.iconSrc}
                                        name={name}
                                        description={''}
                                        tileHandler={() => tileHandler(assistant)}
                                        badges={badges}
                                        mode={DisplayMode.MOBILE}
                                    />
                                )
                            })
                        }
                    </Teaser>
                }

            </div>
        </div>
    )
}

export default MobileHome